import { combineReducers, type Action } from "@reduxjs/toolkit";

import accountSlice from "./slices/Account/accountSlice";
import apiIdentitiesSlice from "./slices/ApiIdentities/apiIdentitiesSlice";
import authSlice from "./slices/Auth/authSlice";
import dataLimitSlice from "./slices/DataLimit/dataLimitSlice";
import detectorSlice from "./slices/DetectorPage/detectorSlice";
import focusModalSlice from "./slices/FocusModal/focusModalSlice";
import hubsSlice from "./slices/Hubs/hubsSlice";
import imageQueriesSlice from "./slices/ImageQueries/imageQueriesSlice";
import onboardingsSlice from "./slices/Onboardings/onboardingsSlice";
import userLimitSlice from "./slices/UserLimit/userLimitSlice";

const combineReducer = combineReducers({
  detector: detectorSlice.reducer,
  auth: authSlice.reducer,
  apiIdentities: apiIdentitiesSlice.reducer,
  focusModal: focusModalSlice.reducer,
  userLimit: userLimitSlice.reducer,
  dataLimit: dataLimitSlice.reducer,
  account: accountSlice.reducer,
  onboardings: onboardingsSlice.reducer,
  imageQueries: imageQueriesSlice.reducer,
  hubs: hubsSlice.reducer,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const rootReducer = (state: any, action: Action) => combineReducer(state, action);

export default rootReducer;
